import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "mb-4 flex items-center gap-2 font-semibold text-gray-900" }
const _hoisted_6 = { class: "hover:underline" }
const _hoisted_7 = { key: 1 }

import Card from 'primevue/card';
import Button from 'primevue/button';
import DefaultChip from '../components/DefaultChip.vue';

import CalculationStepperSummary from '../components/CalculationStepperSummary.vue';

import { useCalculatorsStore } from '../store/calculators';

import { useCurrentClientCalculations } from '../composables/useCurrentClientCalculations';
import { useCurrentCalculatorSegments } from '../composables/useCurrentCalculatorSegments';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationStepper',
  setup(__props) {

const { currentClientCalculations } = useCurrentClientCalculations();
const { getSegmentNameById, getSegmentFirstGroupId } = useCurrentCalculatorSegments();
const calculatorsStore = useCalculatorsStore();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createBlock(_unref(Card), { class: "border border-gray-200 !shadow-none" }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_RouterLink, {
            to: {
              name: 'ClientView',
              params: {
                calculatorId: _ctx.$route.params.calculatorId,
                clientId: _ctx.$route.params.clientId || NaN,
              },
            }
          }, {
            default: _withCtx(() => [
              _createElementVNode("article", _hoisted_3, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex aspect-square w-10 items-center justify-center rounded-lg border transition-colors", {
                  'border-gray-200 bg-white':
                    _ctx.$route.name !== 'NewClientView' && _ctx.$route.name !== 'ClientView',
                  'border-brand-200 bg-brand-25':
                    _ctx.$route.name === 'NewClientView' || _ctx.$route.name === 'ClientView',
                }])
                }, _cache[0] || (_cache[0] = [
                  _createElementVNode("i", { class: "pi pi-user-plus text-gray-700" }, null, -1)
                ]), 2),
                _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "font-semibold text-gray-900" }, "Dane klienta", -1))
              ])
            ]),
            _: 1
          }, 8, ["to"]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "my-1 ml-[19px] h-5 w-0.5 rounded-sm bg-gray-200" }, null, -1)),
          _createElementVNode("article", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex aspect-square w-10 items-center justify-center rounded-lg border", {
                'border-gray-200 bg-white':
                  _ctx.$route.name === 'NewClientView' || _ctx.$route.name === 'ClientView',
                'border-brand-200 bg-brand-25':
                  _ctx.$route.name !== 'NewClientView' && _ctx.$route.name !== 'ClientView',
              }])
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "pi pi-calculator" }, null, -1)
            ]), 2),
            _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "font-semibold text-gray-900" }, "Kalkulacje", -1))
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentClientCalculations), (calculation) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: calculation.uuid
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "my-1 ml-[19px] h-5 w-0.5 rounded-sm bg-gray-200" }, null, -1)),
            _createVNode(_unref(Card), {
              class: _normalizeClass(["basis-[354px] border !shadow-none", {
              'border-gray-200': calculation.uuid !== _ctx.$route.params.calculationId,
              'border-brand-200 !bg-brand-25': calculation.uuid === _ctx.$route.params.calculationId,
            }])
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "pi pi-chevron-right" }, null, -1)),
                  calculation
                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                        key: 0,
                        to: {
                    name: 'CalculationSummaryView',
                    params: {
                      calculatorId: calculation.calculator_id,
                      calculationId: calculation.uuid,
                      clientId: calculation.client_uuid,
                    },
                  }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_6, _toDisplayString(calculation.name) + " " + _toDisplayString(calculation.calculator_id), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true),
                  _createVNode(DefaultChip, {
                    class: "ml-auto",
                    variant: 
                    Number(_ctx.$route.params.calculatorId) === calculation.calculator_id
                      ? 'yellow'
                      : 'gray'
                  
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(calculatorsStore).data?.find(
                      (calculator) => calculator.id === calculation.calculator_id
                    )?.version), 1)
                    ]),
                    _: 2
                  }, 1032, ["variant"])
                ]),
                (calculation.calculator_id === Number(_ctx.$route.params.calculatorId))
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(calculation.calculation_segments, (segment) => {
                      return (_openBlock(), _createBlock(_component_RouterLink, {
                        key: segment.uuid,
                        class: "flex items-center gap-2 text-sm text-gray-700 hover:underline",
                        to: {
                    name: 'CalculationViewItems',
                    params: {
                      ..._ctx.$route.params,
                      calculationId: calculation.uuid,
                      segmentId: segment.segment_id,
                      viewId: _unref(getSegmentFirstGroupId)(segment.segment_id)?.viewId,
                      groupId: _unref(getSegmentFirstGroupId)(segment.segment_id)?.groupId,
                    },
                  }
                      }, {
                        default: _withCtx(() => [
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "gorder-gray-200 h-6 w-2.5 -translate-y-3 border-b-2 border-l-2" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_unref(getSegmentNameById)(segment.segment_id)), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[7] || (_cache[7] = [
                      _createElementVNode("p", { class: "text-sm text-gray-600" }, " Kalkulacja należy do innej wersji kalkulatora. Zmień wersję kalkulatora, aby zobaczyć technologie. ", -1)
                    ]))),
                _createVNode(_component_RouterLink, {
                  to: {
                  name: 'SelectSegmentView',
                  params: {
                    calculatorId: calculation.calculator_id,
                    clientId: _ctx.$route.params.clientId,
                    calculationId: calculation.uuid,
                  },
                }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      class: "mt-4 w-full font-semibold",
                      size: "small",
                      outlined: ""
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createElementVNode("i", { class: "pi pi-plus" }, null, -1),
                        _createElementVNode("span", { class: "my-auto self-stretch px-0.5" }, "Dodaj technologię", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 2
            }, 1032, ["class"])
          ], 64))
        }), 128)),
        (_ctx.$route.params.clientId && _ctx.$route.params.calculatorId)
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              to: {
            name: 'NewCalculationView',
            params: {
              calculatorId: _ctx.$route.params.calculatorId,
              clientId: _ctx.$route.params.clientId,
            },
          }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  class: "mt-4 w-full font-semibold",
                  size: "small"
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createElementVNode("i", { class: "pi pi-plus" }, null, -1),
                    _createElementVNode("span", { class: "my-auto self-stretch px-0.5" }, "Dodaj kalkulacje", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (_ctx.$route.params.calculationId)
          ? _withDirectives((_openBlock(), _createBlock(CalculationStepperSummary, {
              key: 1,
              class: "mt-6"
            }, null, 512)), [
              [_directive_auto_animate]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})